import $ from 'jquery';

/**
 * Update select dropdown options with new items.
 */
export function updateSelectOptions(
	$select: JQuery,
	items: Array<{ id: number; name: string }>,
	placeholder: string,
	preserveValue = true
): void {
	const currentValue = preserveValue ? $select.val() : null;

	// Clear and rebuild options
	$select.empty();
	$select.append($('<option>', { value: '', text: placeholder }));

	items.forEach((item) => {
		$select.append(
			$('<option>', {
				value: item.id.toString(),
				text: item.name,
			})
		);
	});

	// Restore previous value if still valid
	if (
		currentValue &&
		items.some((item) => item.id.toString() === currentValue)
	) {
		$select.val(currentValue);
	}

	$select.trigger('change');
}

/**
 * Update radio button group with new items.
 */
export function updateRadioButtons(
	$radioContainer: JQuery,
	items: Array<{ id: number; name: string }>,
	formId: number,
	fieldId: number,
	preserveValue = true
): void {
	const currentValue = preserveValue
		? $radioContainer.find('input[type="radio"]:checked').val()
		: null;

	// Clear and rebuild radio buttons
	$radioContainer.empty();

	items.forEach((item, index) => {
		const inputId = `choice_${formId}_${fieldId}_${index}`;
		const isChecked =
			currentValue && currentValue.toString() === item.id.toString();

		const $li = $('<li>', { class: 'gchoice' });
		const $input = $('<input>', {
			type: 'radio',
			name: `input_${fieldId}`,
			id: inputId,
			value: item.id.toString(),
		});

		if (isChecked) {
			$input.prop('checked', true);
		}

		const $label = $('<label>', {
			for: inputId,
			text: item.name,
		});

		$li.append($input, $label);
		$radioContainer.append($li);
	});

	// Trigger change if value was selected
	if (currentValue) {
		$radioContainer.find('input[type="radio"]:checked').trigger('change');
	}
}
